/**
 * @function errorHandler - обрабатывает ошибку инициализации карты на маршрутах
 * @param {string} error - сообщение об ошибке
 * */

export default function errorHandler(error) {
    document.querySelector('.train-map').remove();

    console.error(error);
}
